export default "__VITE_ASSET__BYhOTGmj__"